import axios from 'axios'
import miniToastr from 'mini-toastr'
import { EventBus } from '../../../event-bus.js'

import configAll from '../../../../config/index.cjs'

const config = configAll[process.env.NODE_ENV === 'production' ? 'build' : (process.env.NODE_ENV === 'prodlocal') ? 'prodlocal' : 'dev']

const API_URL = config.urlServerSpiritual
const COURSE_URL = `${API_URL}api/spi/courses/`
const MODULE_URL = `${API_URL}api/spi/coursemodule/`
const CONTENT_URL = `${API_URL}api/spi/coursemodulecontent/`

export default {
  namespaced: true,
  state: {
    items: [],
    totalItems : 0,
    item: {},
    selectedModule: 0,
    currentLength: 0,
    modules: [],
    itemsOne: [],
    itemsTwo: [],
    totalContentItems: 0,
  },
  mutations: {
    setCourses (state, items) {
      // const items = obj.items
      // const aa1 = items
      //
      // aa1.forEach((item) => {
      //   const tags = []
      //   item.Tags.forEach((tag) => {
      //     tags.push(tag.title)
      //   })
      //   // eslint-disable-next-line
      //   item.tags = tags.join(', ');
      // })
      items.rows.forEach((item) => {
        const tags = []
        item.Tags.forEach((tag) => {
          tags.push(tag.title)
        })
        // eslint-disable-next-line
        item.tags = tags.join(', ');
      })

      // eslint-disable-next-line
      state.items = items.rows;
      // eslint-disable-next-line
      state.totalItems = items.count;

    },
    addCourse (state, item) {
      // eslint-disable-next-line
      state.items.push(item);
    },
    setModules(state, obj) {
      // eslint-disable-next-line
      state.modules = obj.items;
      if (state.selectedModule == 0 && obj.items.length && !obj.notrigger) {
        EventBus.$emit('trigger-module', obj.items[0].id)
      }

    },
    setModuleContent (state, items) {
      // const items = obj.items
      const aa1 = items.rows
      //
      // aa1.forEach((item) => {
      //   const tags = []
      //   item.Tags.forEach((tag) => {
      //     tags.push(tag.title)
      //   })
      //   // eslint-disable-next-line
      //   item.tags = tags.join(', ');
      // })
      // items.rows.forEach((item) => {
      //   const tags = []
      //   item.Tags.forEach((tag) => {
      //     tags.push(tag.title)
      //   })
      //   // eslint-disable-next-line
      //   item.tags = tags.join(', ');
      // })

      const one = []
      const two = []

      aa1.forEach((item, key) => {
        // const tags = []
        // item.Tags.forEach((tag) => {
        //   tags.push(tag.title)
        // })
        // eslint-disable-next-line
        // item.tags = tags.join(', ');
        if (key % 2 === 0) {
          one.push(item)
          // eslint-disable-next-line
          // state.currentItemList = 0;
        }
        if (key % 2 === 1) {
          two.push(item)
          // eslint-disable-next-line
          // state.currentItemList = 1;
        }
      })

      // eslint-disable-next-line
      state.itemsOne = one;
      // eslint-disable-next-line
      state.itemsTwo = two;
      // eslint-disable-next-line
      state.totalContentItems = items.count;

    },
    addContent(state, item) {
      if (state.totalContentItems % 2 == 0) {
        state.itemsOne.push(item);
      } else {
        state.itemsTwo.push(item);
      }
      state.totalContentItems++;
    },
    addModule(state, item) {
      state.modules.push(item)
    }

    // setBook (state, item) {
    //   if (!item.BookChapters.length) {
    //     // eslint-disable-next-line
    //     item.BookChapters = [{ BookChapterSummaries: [] }];
    //   }
    //   // eslint-disable-next-line
    //   state.item = item;
    // },
    // addChapter (state, chapter) {
    //   // eslint-disable-next-line
    //   chapter.BookChapterSummaries = [];
    //   // eslint-disable-next-line
    //   chapter.BookChapterSummariesLeft = [];
    //   // eslint-disable-next-line
    //   chapter.BookChapterSummariesRight = [];
    //   // console.log('add step');
    //   if (state.item.BookChapters) {
    //     // eslint-disable-next-line
    //     state.item.BookChapters.push(chapter);
    //   } else {
    //     // eslint-disable-next-line
    //     state.item.BookChapters = [chapter];
    //   }
    // },
    // deleteChapter (state, chapterId) {
    //   const findChapter = state.item.BookChapters.find(item1 => item1.id === chapterId)
    //   if (findChapter) {
    //     const index = state.item.BookChapters.indexOf(findChapter)
    //     if (index > -1) {
    //       state.item.BookChapters.splice(index, 1)
    //     }
    //   }
    // },
    // setSummary (state, chapterId) {
    //   const findChapter = state.item.BookChapters.find(item1 => item1.id === chapterId)
    //   if (findChapter) {
    //     const indexChapter = state.item.BookChapters.indexOf(findChapter)
    //     // eslint-disable-next-line
    //     state.selectedChapter = indexChapter;
    //   }
    // },
    // addSummary (state, summary) {
    //   const findChapter = state.item.BookChapters.find(item1 => item1.id === summary.chapter_id)
    //   if (findChapter) {
    //     const indexChapter = state.item.BookChapters.indexOf(findChapter)
    //
    //     if (findChapter.BookChapterSummaries) {
    //       // eslint-disable-next-line
    //       state.item.BookChapters[indexChapter].BookChapterSummaries.push(summary);
    //     } else {
    //       // eslint-disable-next-line
    //       state.item.BookChapters[indexChapter].BookChapterSummaries = [summary];
    //     }
    //     // eslint-disable-next-line
    //     state.currentLength++;
    //   }
    // },
    // deleteSummary (state, obj) {
    //   const findChapter = state.item.BookChapters.find(item1 => item1.id === obj.chapterId)
    //   if (findChapter) {
    //     const indexChapter = state.item.BookChapters.indexOf(findChapter)
    //     // eslint-disable-next-line
    //     const findSummary = findChapter.BookChapterSummaries.find(item1 => item1.id === obj.summaryId);
    //     if (findSummary) {
    //       const index = findChapter.BookChapterSummaries.indexOf(findSummary)
    //       if (index > -1) {
    //         state.item.BookChapters[indexChapter].BookChapterSummaries.splice(index, 1)
    //       }
    //     }
    //     // eslint-disable-next-line
    //     state.currentLength--;
    //   }
    // },
    // addTag (state, obj) {
    //   let item2 = state.toReadBooks.find(item1 => item1.id === obj.book_id)
    //   if (!item2) {
    //     item2 = state.readBooks.find(item1 => item1.id === obj.book_id)
    //   }
    //   if (!item2) {
    //     item2 = state.favBooks.find(item1 => item1.id === obj.book_id)
    //   }
    //   if (item2) {
    //     item2.tags = item2.tags.replace('undefined, ', '')
    //     // console.log(item2.tags.length);
    //     if (item2.tags.trim().length) {
    //       item2.tags = `${item2.tags}, ${obj.title}`
    //     } else {
    //       item2.tags = `${obj.title}`
    //     }
    //   }
    // },
    // deleteTag (state, obj) {
    //   let item2 = state.toReadBooks.find(item1 => item1.id === obj.book_id)
    //   if (!item2) {
    //     item2 = state.readBooks.find(item1 => item1.id === obj.book_id)
    //   }
    //   if (!item2) {
    //     item2 = state.favBooks.find(item1 => item1.id === obj.book_id)
    //   }
    //   if (item2) {
    //     const aa = new RegExp(`(, ?)${obj.title}`, 'g')
    //     item2.tags = item2.tags.replace(aa, '')
    //     const cc = new RegExp(`\\b${obj.title}(,?)`, 'g')
    //     item2.tags = item2.tags.replace(cc, '')
    //   }
    // }
  },
  actions: {
    getCourses ({ commit }, opts) {
      const offset = (opts.currentPage - 1) * opts.perpage
      const limit = opts.perpage
      let query = `offset=${offset}&limit=${limit}`
      axios.get(`${COURSE_URL}?${query}`)
        .then((response) => {
          commit('setCourses', response.data )
        })
        .catch((err) => {
          // eslint-disable-next-line
          miniToastr.error(err.response.data.errorMessage, 'Get Courses failed!', 1500);
        })
    },
    add ({ commit }, payload) {
      axios.post(COURSE_URL, payload)
        .then((response) => {
          commit('addCourse', response.data)
          miniToastr.success('Added Course', '', 1500)
        })
        .catch((err) => {
          // eslint-disable-next-line
          miniToastr.error(err.response.data.errorMessage, 'Add Course failed!', 1500);
        })
    },
    // eslint-disable-next-line
    edit ({ commit }, obj) {
      axios.put(COURSE_URL, obj.payload, { params: { id: obj.payload.id } })
        .then(() => {
          // commit('editBook', obj)
          miniToastr.success('Edited Course', '', 1500)
        })
        .catch((err) => {
          // eslint-disable-next-line
          miniToastr.error(err.response.data.errorMessage, 'Edit Course failed!', 1500);
        })
    },
    getModules({ commit }, obj) {
      axios.get(`${MODULE_URL}${obj.id}`)
        .then((response) => {
          commit('setModules', {items: response.data, notrigger: obj.notrigger} )
        })
        .catch((err) => {
          // eslint-disable-next-line
          miniToastr.error(err.response.data.errorMessage, 'Get Modules failed!', 1500);
        })
    },
    getModuleContent({ commit }, opts) {
      const offset = (opts.currentPage - 1) * opts.perpage
      const limit = opts.perpage
      let query = `offset=${offset}&limit=${limit}`
      axios.get(`${CONTENT_URL}${opts.moduleid}?${query}`)
        .then((response) => {
          commit('setModuleContent', response.data )
        })
        .catch((err) => {
          // eslint-disable-next-line
          miniToastr.error(err.response.data.errorMessage, 'Get Module Content failed!', 1500);
        })
    },
    addContent({commit, state}, payload) {
      payload.flag_order = state.totalContentItems + 1;
      axios.post(CONTENT_URL, payload)
        .then((response) => {
          commit('addContent', response.data)
          miniToastr.success('Added Content', '', 1500)
        })
        .catch((err) => {
          // eslint-disable-next-line
          miniToastr.error(err.response.data.errorMessage, 'Add Content failed!', 1500);
        })
    },
    // eslint-disable-next-line
    editContent({commit}, payload) {
      axios.put(CONTENT_URL, payload, { params: { id: payload.id } })
        .then(() => {
          miniToastr.success('Edited Content', '', 1500)
        })
        .catch((err) => {
          // eslint-disable-next-line
          miniToastr.error(err.response.data.errorMessage, 'edit Content failed!', 1500);
        })
    },
    addModule({commit}, payload) {
      axios.post(MODULE_URL, payload)
        .then((response) => {
          commit('addModule', response.data)
          miniToastr.success('Added Module', '', 1500)
        })
        .catch((err) => {
          // eslint-disable-next-line
          miniToastr.error(err.response.data.errorMessage, 'Add Module failed!', 1500);
        })
    },
    // eslint-disable-next-line
    editModule({commit}, payload) {
      axios.put(MODULE_URL, payload, { params: { id: payload.id } })
        .then(() => {
          miniToastr.success('Edited Module', '', 1500)
        })
        .catch((err) => {
          // eslint-disable-next-line
          miniToastr.error(err.response.data.errorMessage, 'Edit Module failed!', 1500);
        })
    },
    // getBook ({ commit }, id) {
    //   axios.get(`${BOOK_URL}${id}`)
    //     .then((response) => {
    //       // eslint-disable-next-line
    //       commit('setBook', response.data);
    //     })
    //     .catch((err) => {
    //       // eslint-disable-next-line
    //       miniToastr.error(err.response.data.errorMessage, 'Get Book Details failed!', 1500);
    //     })
    // },
    // addChapter ({ commit }, payload) {
    //   axios.post(ADD_CHAPTER_URL, payload)
    //     .then((response) => {
    //       commit('addChapter', response.data)
    //       miniToastr.success('Added Chapter', '', 1500)
    //     })
    //     .catch((err) => {
    //       miniToastr.error(err.response.data.errorMessage, 'Add Chapter failed!', 1500)
    //     })
    // },
    // // eslint-disable-next-line
    // editChapter ({ commit }, payload) {
    //   axios.put(ADD_CHAPTER_URL, payload, { params: { id: payload.id } })
    //     .then(() => {
    //       // commit('editStep', response.data);
    //       miniToastr.success('Edited Chapter', '', 1500)
    //       EventBus.$emit('close-modal')
    //     })
    //     .catch((err) => {
    //       miniToastr.error(err.response.data.errorMessage, 'Edit Chapter failed!', 1500)
    //     })
    // },
    //
    // deleteChapter ({ commit }, chapterId) {
    //   axios.delete(`${API_URL}api/personal/bookchapter/${chapterId}`)
    //     .then(() => {
    //       commit('deleteChapter', chapterId)
    //       miniToastr.success('Deleted Chapter', '', 1500)
    //       EventBus.$emit('hide-dialog')
    //       // context.$modal.hide('dialog');
    //     })
    //     .catch((err) => {
    //       miniToastr.error(err.response.data.errorMessage, 'Delete Chapter failed!', 1500)
    //     })
    // },
    // getSummary ({ commit }, chapterId) {
    //   commit('setSummary', chapterId)
    //   // axios.get(`${ADD_CHAPTER_URL}${chapterId}`)
    //   //   .then((response) => {
    //   //     // eslint-disable-next-line
    //   //     commit('setSummary', response.data);
    //   //   })
    //   //   .catch((err) => {
    //   //     // eslint-disable-next-line
    //   //     miniToastr.error(err.response.data.errorMessage, 'Get Summary failed!', 1500);
    //   //   });
    // },
    // addSummary ({ commit }, payload) {
    //   axios.post(ADD_SUMMARY_URL, payload)
    //     .then((response) => {
    //       // console.log(response.data);
    //       commit('addSummary', response.data)
    //       miniToastr.success('Added Summary', '', 1500)
    //     })
    //     .catch((err) => {
    //       miniToastr.error(err.response.data.errorMessage, 'Add Summary failed!', 1500)
    //     })
    // },
    // // eslint-disable-next-line
    // editSummary ({ commit }, payload) {
    //   axios.put(ADD_SUMMARY_URL, payload, { params: { id: payload.id } })
    //     .then(() => {
    //       // commit('editStep', response.data);
    //       miniToastr.success('Edited Summary', '', 1500)
    //       EventBus.$emit('close-modal')
    //     })
    //     .catch((err) => {
    //       miniToastr.error(err.response.data.errorMessage, 'Edit Summary failed!', 1500)
    //     })
    // },
    // deleteSummary ({ commit }, { chapterId, summaryId }) {
    //   axios.delete(`${API_URL}api/personal/bookchaptersummary/${summaryId}`)
    //     .then(() => {
    //       commit('deleteSummary', { summaryId, chapterId })
    //       miniToastr.success('Deleted Summary', '', 1500)
    //       EventBus.$emit('hide-dialog')
    //       // context.$modal.hide('dialog');
    //     })
    //     .catch((err) => {
    //       miniToastr.error(err.response.data.errorMessage, 'Delete Summary failed!', 1500)
    //     })
    // },
    // // eslint-disable-next-line
    // editSummaryOrder ({ commit }, payload) {
    //   axios.put(ADD_SUMMARY_URL, payload, { params: { id: payload.id } })
    //     .then(() => {
    //       // commit('editStep', response.data);
    //       miniToastr.success('Edited Summary Order', '', 1500)
    //       EventBus.$emit('close-modal')
    //     })
    //     .catch((err) => {
    //       miniToastr.error(err.response.data.errorMessage, 'Edit Summary Order failed!', 1500)
    //     })
    // },
    // addTag ({ commit }, tag) {
    //   axios.post(`${API_URL}api/personal/tag/book/link`, tag)
    //     .then((response) => {
    //       commit('addTag', { book_id: tag.book_id, title: response.data.title })
    //       miniToastr.success('Added Tag!', '', 1500)
    //     })
    //     .catch((err) => {
    //       miniToastr.error(err.response.data.errorMessage, 'Add Tag failed!', 1500)
    //     })
    // },
    // deleteTag ({ commit }, tag) {
    //   axios.post(`${API_URL}api/personal/tag/book/link/rm`, tag)
    //     .then((response) => {
    //       commit('deleteTag', { book_id: tag.book_id, title: response.data.title })
    //       miniToastr.success('Deleted Tag!', '', 1500)
    //     })
    //     .catch((err) => {
    //       miniToastr.error(err.response.data.errorMessage, 'Delete Tag failed!', 1500)
    //     })
    // }
  },
  getters: {}
}
